import React from 'react';
import i18n from 'i18n';

export default React.createContext(i18n);
